/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTheme, type Theme } from '@mui/material';
import type { AtlasThemeTokens } from '@diligentcorp/atlas-design-tokens';

type Semantic = AtlasThemeTokens['semantic'];
type Core = AtlasThemeTokens['core'];

// TODO: Ask the Atlas team to export the correct Theme interface
export interface AtlasTheme extends Theme {
  tokens: AtlasThemeTokens & {
    component: AtlasThemeTokens['component'] & {
      dragAndDrop: any;
    };
  };
  presets: {
    TooltipPresets: any;
  };
}

export type WithTheme<T> = T & { theme?: AtlasTheme };

export function useAtlasSemanticThemeTokens(): Semantic {
  const {
    tokens: { semantic },
  } = useTheme<AtlasTheme>();

  return semantic;
}

export function useAtlasCoreThemeTokens(): Core {
  const {
    tokens: { core },
  } = useTheme<AtlasTheme>();

  return core;
}

export function useAtlasTheme(): AtlasTheme {
  return useTheme<AtlasTheme>();
}
